import { SEOData } from 'shared/config/routeConfig/routeConfig';

const blogSeoMap: { [key: string]: SEOData } = {
  chto_takoe_erir: {
    metaTitle:
      'Что такое ЕРИР и его роль в маркировке интернет-рекламы | ОРД от SberAds',
    metaDescription:
      'ЕРИР (Единый реестр интернет-рекламы) – это структура, созданная Роскомнадзором для реализации норм по маркировке рекламы в соответствии с требованиями статьи 18.1 закона «О рекламе» №38-ФЗ. ЕРИР обеспечивает контроль и прозрачность в сфере интернет-рекламы и обязывает рекламных агентов и других игроков рынка передавать данные о рекламных материалах, составе и участниках рекламных кампаний в Единый реестр интернет-рекламы.',
    metaKeyWords:
      'маркировка рекламы в интернете, ерир, единый реестр интернет рекламы, оператор рекламных данных',
  },
  chto_takoe_operator_reklamnih_dannih: {
    metaTitle:
      'Что такое оператор рекламных данных и как маркировать рекламу в ОРД | ОРД от SberAds',
    metaDescription:
      'ОРД – оператор рекламных данных – структура, аккредитованная Роскомнадзором, IT платформа, на которой можно получить рекламный маркер и передать сведения о рекламе для их последующей отправки в ЕРИР. В данной статье мы рассмотрим, что такое ОРД и об основых правилах работы с ОРД.',
    metaKeyWords:
      'маркировка рекламы в интернете, оператор рекламных данных, орд',
  },
  markirovka_reklami_v_internete: {
    metaTitle:
      'Маркировка рекламы в интернете: обзор ключевых моментов | ОРД от SberAds',
    metaDescription:
      'В данной статье перечислены ключевые моменты и определения, касающиеся маркировки рекламы в интернете, изменения в законодательстве и меры ответственности за несоблюдение новых правил закона № 347-ФЗ (п.3 ст.1 от 02.07.2021г.).',
    metaKeyWords:
      'маркировка рекламы в интернете, маркировка рекламы статьи, регистрация в орд',
  },
  markirovka_reklami_v_telegram: {
    metaTitle:
      'Маркировка рекламы в Телеграм: пошаговая инструкция  | ОРД от SberAds',
    metaDescription:
      'Согласно поправкам к закону о рекламе № 347-ФЗ от 1 сентября 2022 года, все рекламные публикации (посты) в Телеграм должны быть промаркированы. В данной статье мы пошагово разберём, как маркируется реклама в Телеграм.',
    metaKeyWords:
      'маркировка рекламы в интернете, маркировка рекламы в телеграм',
  },
  otvetstvennost_za_shtrafi: {
    metaTitle:
      'Ответственность и штрафы за отсутствие маркировки рекламы в интернете | ОРД от SberAds',
    metaDescription:
      '1 сентября 2023 года были введены штрафы и вступил в силу закон об административной ответственности за нарушение норм и правил маркировки интернет рекламы, размеры которых зависят от типа правонарушения.',
    metaKeyWords: 'маркировка рекламы в интернете',
  },
  poryadok_razmeshenia_markera_v_reklame: {
    metaTitle:
      'Порядок размещения маркера (erid:xxxxx) в рекламе с примерами | ОРД от SberAds',
    metaDescription:
      'Согласно Федеральному закону от 02.07.2021 N 347-ФЗ (пункт 18.1) все рекламные материалы, размещаемые в сети интернет на территории РФ, должны быть промаркированы и содержать официальные атрибуты маркировки.  В данной статье рассматриваются основные правила размещения маркера в рекламных публикациях.',
    metaKeyWords:
      'маркировка рекламы в интернете, маркер erid, erid, размещение маркера, правила размещения erid',
  },
};

export default blogSeoMap;
